// extracted by mini-css-extract-plugin
export var noteNumber = "L_cw";
export var textFootNote = "L_cx";
export var tooltipText = "L_cy";
export var articlesourceContianer = "L_cz";
export var sampleSpacing = "L_cB";